module.exports = __webpack_public_path__ + "static/img/アセット 33@2x.5626632.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_history/アセット 33@2x.png
// module id = b5ax
// module chunks = 1